var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicProfileBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 382,
    viewBox: "0 0 1440 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.368 107.316L879.375 107.315C928.68 99.2261 978.166 91.1078 1027.08 88.0048C1041 87.0939 1054.86 86.2685 1068.68 85.4453C1130.93 81.7371 1192.41 78.0751 1255.1 66.8487C1315.37 56.0686 1396.03 41.0843 1440 0V381.851H0V1.62632C24.0396 57.6315 75.1254 105.981 139.718 117.775C152.505 120.113 165.277 122.524 178.055 124.937L178.056 124.937C232.857 135.283 287.787 145.654 344.636 150.342C406.304 155.474 469.966 153.896 532.916 152.335H532.917L532.999 152.333C542.898 152.088 552.78 151.843 562.633 151.625C612.335 150.493 662.571 141.832 712.655 133.197L712.656 133.197C739.752 128.526 766.802 123.862 793.7 120.402C822.096 116.711 850.701 112.019 879.368 107.316Z",
    fill: "#263D4B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2928_130788",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 382
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M879.368 107.316L879.375 107.315C928.68 99.2261 978.166 91.1078 1027.08 88.0048C1041 87.0939 1054.86 86.2685 1068.68 85.4453C1130.93 81.7371 1192.41 78.0751 1255.1 66.8487C1315.37 56.0686 1396.03 41.0843 1440 0V381.851H0V1.62632C24.0396 57.6315 75.1254 105.981 139.718 117.775C152.505 120.113 165.277 122.524 178.055 124.937L178.056 124.937C232.857 135.283 287.787 145.654 344.636 150.342C406.304 155.474 469.966 153.896 532.916 152.335H532.917L532.999 152.333C542.898 152.088 552.78 151.843 562.633 151.625C612.335 150.493 662.571 141.832 712.655 133.197L712.656 133.197C739.752 128.526 766.802 123.862 793.7 120.402C822.096 116.711 850.701 112.019 879.368 107.316Z",
    fill: "#263D4B"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2928_130788)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    filter: "url(#filter0_f_2928_130788)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M791.274 154.403C868.51 144.364 947.296 126.913 1024.66 122.005C1101.27 116.991 1176.07 114.568 1252.68 100.849C1318.01 89.1629 1407.31 72.5355 1447.85 23.0712C1471.9 -6.19038 1461.65 -77.0645 1437.88 -101.706C1395.49 -145.323 1309.67 -150.613 1246.73 -167.667C1100.65 -207.305 948.774 -242.211 790.21 -251.327C638.804 -265.064 481.027 -246.47 327.481 -245.905C268.173 -245.64 196.616 -253.645 140.619 -226.012C83.418 -197.741 19.9523 -141.92 -4.13976 -93.2305C-48.5493 -3.55851 23.3602 130.973 137.291 151.776C204.917 164.138 272.103 178.561 342.209 184.343C413.602 190.284 487.668 187.232 560.206 185.625C636.796 183.881 714.655 164.258 791.274 154.403Z",
    fill: "#253D4B",
    fillOpacity: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2928_130788",
    x: -49.4297,
    y: -288.375,
    width: 1543,
    height: 508.226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_2928_130788"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicProfileBg);
export default __webpack_public_path__ + "static/media/graphic-profile-bg.407c9981a895c519a62819dbbeae95d8.svg";
export { ForwardRef as ReactComponent };